import { formatAssessmentsReportingData, formatAssessmentsReportingParams } from './format';
import { formatPagingParams, handleError } from '/b2b/common/services/helpers';

import API from '/b2b/common/helpers/API';
import { API_NAME } from '#config/runtimeconfig';

export const fetchAssessmentsReportingData = queryStringParameters => {
    const options = {
        queryStringParameters: {
            ...formatPagingParams(queryStringParameters),
            ...formatAssessmentsReportingParams(queryStringParameters),
        },
    };

    return API.get(API_NAME, `/assessments-reporting`, options)
        .catch(handleError)
        .then(formatAssessmentsReportingData);
};
